import Vue from 'vue'
// import { WebHistory, Router } from 'vue-router'
import Router from 'vue-router'
import { trackPageView } from '@/analytics'

Vue.use(Router)

const DEFAULT_META = {
    siteName: 'BIG Basketball',
    title: 'BIG Basketball',
    description: 'BIG Basketball: νέα, αποτελέσματα, στατιστικά, ομάδες και παίκτες.',
    image: '/icon-512.png'
}

const ROUTE_META = {
    News: {
        title: 'Νέα | BIG Basketball',
        description: 'Τελευταία νέα και ανακοινώσεις για το BIG Basketball.'
    },
    Schedule: {
        title: 'Πρόγραμμα | BIG Basketball',
        description: 'Δείτε το πρόγραμμα αγώνων και τις επόμενες αναμετρήσεις.'
    },
    Standings: {
        title: 'Βαθμολογία | BIG Basketball',
        description: 'Παρακολουθήστε τη βαθμολογία και την πορεία των ομάδων.'
    },
    Teams: {
        title: 'Ομάδες | BIG Basketball',
        description: 'Ανακαλύψτε όλες τις ομάδες της διοργάνωσης.'
    },
    Team: {
        title: 'Ομάδα | BIG Basketball',
        description: 'Στοιχεία ομάδας, ρόστερ και στατιστικά.'
    },
    FreeAgents: {
        title: 'Free Agents | BIG Basketball',
        description: 'Διαθέσιμοι παίκτες χωρίς ομάδα, με στατιστικά και προηγούμενες ομάδες.'
    },
    Player: {
        title: 'Παίκτης | BIG Basketball',
        description: 'Προφίλ παίκτη και αναλυτικά στατιστικά.'
    },
    Match: {
        title: 'Αγώνας | BIG Basketball',
        description: 'Λεπτομέρειες αγώνα, σκορ και στατιστικά.'
    },
    Stats: {
        title: 'Στατιστικά | BIG Basketball',
        description: 'Προηγμένα στατιστικά ομάδων και παικτών.'
    },
    Penalties: {
        title: 'Ποινές | BIG Basketball',
        description: 'Οι ποινές των παικτών ανά σεζόν.'
    },
    Article: {
        title: 'Άρθρο | BIG Basketball',
        description: 'Διαβάστε άρθρα και αναλύσεις για το BIG Basketball.'
    }
}

const upsertMetaTag = (selector, attrs) => {
    let el = document.head.querySelector(selector)
    if (!el) {
        el = document.createElement('meta')
        document.head.appendChild(el)
    }
    Object.keys(attrs).forEach(key => {
        el.setAttribute(key, attrs[key])
    })
}

const setPageMeta = ({ title, description, image, url, type }) => {
    document.title = title

    upsertMetaTag('meta[name="description"]', { name: 'description', content: description })
    upsertMetaTag('meta[property="og:site_name"]', { property: 'og:site_name', content: DEFAULT_META.siteName })
    upsertMetaTag('meta[property="og:title"]', { property: 'og:title', content: title })
    upsertMetaTag('meta[property="og:description"]', { property: 'og:description', content: description })
    upsertMetaTag('meta[property="og:image"]', { property: 'og:image', content: image })
    upsertMetaTag('meta[property="og:url"]', { property: 'og:url', content: url })
    upsertMetaTag('meta[property="og:type"]', { property: 'og:type', content: type })
    upsertMetaTag('meta[name="twitter:card"]', { name: 'twitter:card', content: 'summary' })
    upsertMetaTag('meta[name="twitter:title"]', { name: 'twitter:title', content: title })
    upsertMetaTag('meta[name="twitter:description"]', { name: 'twitter:description', content: description })
    upsertMetaTag('meta[name="twitter:image"]', { name: 'twitter:image', content: image })
}

const routes = [
    {
        path: '/',
        redirect: '/News'
    },
    {
        path: '/Schedule',
        component: () => import('@/routes/Schedule'),
        name: 'Schedule',
        meta: 'Πρόγραμμα'
    },
    {
        path: '/Standings',
        alias: '/',
        component: () => import('@/routes/Standings'),
        name: 'Standings',
        meta: 'Βαθμολογία'
    },
    {
        path: '/Teams',
        component: () => import('@/routes/Teams'),
        name: 'Teams',
        meta: 'Ομάδες'
    },
    {
        path: '/Team/:id',
        component: () => import('@/routes/Team'),
        name: 'Team',
        meta: 'Ομάδα'
    },
    {
        path: '/Player/:id',
        component: () => import('@/routes/Player'),
        name: 'Player',
        meta: 'Παίκτης'
    },
    {
        path: '/Match/:id',
        component: () => import('@/routes/Match'),
        name: 'Match',
        meta: 'Παιχνίδι'
    },
    {
        path: '/Facebook/Post/Match/:id',
        component: () => import('@/routes/FacebookPostMatch'),
        name: 'FacebookPostMatch',
        meta: 'Παιχνίδι'
    },
    {
        path: '/Courts',
        component: () => import('@/routes/Courts'),
        name: 'Courts',
        meta: 'Γήπεδα'
    },
    {
        path: '/News',
        component: () => import('@/routes/News'),
        name: 'News',
        meta: 'Νέα'
    },
    {
        path: '/Article/:id',
        component: () => import('@/routes/Article'),
        name: 'Article',
        meta: 'Άρθρο'
    },
    {
        path: '/Profile',
        component: () => import('@/routes/Profile'),
        name: 'Profile',
        meta: 'Προφίλ'
    },
    {
        path: '/MatchChanges',
        component: () => import('@/routes/MatchChanges'),
        name: 'MatchChanges',
        meta: 'Τα αιτήματά μου'
    },
    {
        path: '/Register',
        component: () => import('@/routes/Register'),
        name: 'Register',
        meta: 'Εγγραφή'
    },
    {
        path: '/Philosophy',
        component: () => import('@/routes/AboutUs'),
        name: 'Philosophy',
        meta: 'Φιλοσοφία'
    },
    {
        path: '/Regulations',
        component: () => import('@/routes/Regulations'),
        name: 'Regulations',
        meta: 'Κανονισμός'
    },
    {
        path: '/ContactUs',
        component: () => import('@/routes/ContactUs'),
        name: 'ContactUs',
        meta: 'Επικοινωνία'
    },
    {
        path: '/Stats',
        component: () => import('@/routes/Stats'),
        name: 'Stats',
        meta: 'Στατιστικά'
    },
    {
        path: '/Penalties',
        component: () => import('@/routes/Penalties'),
        name: 'Penalties',
        meta: 'Ποινές'
    },
    {
        path: '/FreeAgents',
        component: () => import('@/routes/FreeAgents'),
        name: 'FreeAgents',
        meta: 'Free Agents'
    },
    {
        path: '/PrivacyPolicy',
        component: () => import('@/routes/PrivacyPolicy'),
        name: 'PrivacyPolicy',
        meta: 'Πολιτική Απορρήτου'
    },
    {
        path: '/LiveScore/:id',
        component: () => import('@/routes/LiveScore'),
        name: 'LiveScore',
        meta: 'Live Score'
    },
    {
        path: '/LiveStat/:id',
        component: () => import('@/routes/LiveStat'),
        name: 'LiveStat',
        meta: 'Live Stat'
    },
    {
        path: '/LiveData/:id',
        component: () => import('@/routes/LiveData'),
        name: 'LiveData',
        meta: 'Live Data'
    },
    {
        path: '/ActivePlayers/:id',
        component: () => import('@/components/ActivePlayers'),
        name: 'ActivePlayers',
        meta: 'ActivePlayers'
    }
]

const scrollBehavior = (to, from, savedPosition) => {
    const scrollpos = { left: 0, top: 0 }
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(scrollpos)
        }, 600) // transition just before 600ms
    })
}

const router = new Router({
    // history: new WebHistory(),
    scrollBehavior,
    routes
})

router.beforeEach((to, from, next) => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    return next()
})

router.afterEach((to) => {
    const routeMeta = ROUTE_META[to.name] || {}
    const fallbackFromRoute = typeof to.meta === 'string' && to.meta
        ? `${to.meta} | ${DEFAULT_META.siteName}`
        : DEFAULT_META.title

    setPageMeta({
        title: routeMeta.title || fallbackFromRoute,
        description: routeMeta.description || DEFAULT_META.description,
        image: DEFAULT_META.image,
        url: window.location.href,
        type: to.name === 'Article' ? 'article' : 'website'
    })

    trackPageView(to)
})

export default router
